import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import ModalBox from "components/modal/ModalBox";
import Switch from "components/Switch/Switch";
import TextEditor from "components/TextEditor/TextEditor";
import { cityWiseSectionUpdate } from "services/citypages";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { rawToHtmlConverter, wrapImagesWithFigure } from "utils";
import { Input } from "components/Form";

const UpdateCityWiseSection = ({ open, onClose, data, cityId, citywisecenterListing }) => {
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [formData, setFormData] = useState({
        section: "",
        description: EditorState.createEmpty(),
        ish1tag: 0,
    });

    const [errorField, setErrorField] = useState({});

    // 🔹 Prefill when modal opens
    useEffect(() => {
        if (data) {
            setFormData({
                section: data.section || "",
                description: data.description
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(convertFromHTML(data.description))
                    )
                    : EditorState.createEmpty(),
                ish1tag: data.ish1tag ? 1 : 0,   // ✅ normalize to 1/0
            });
        }
    }, [data]);


    // ******** Validation ********
    const handleValidation = () => {
        let errors = {};
        let valid = true;
        if (!formData.section) {
            errors.section = "Please enter heading";
            valid = false;
        }
        if (!formData.description.getCurrentContent().hasText()) {
            errors.description = "Please enter description";
            valid = false;
        }
        setErrorField(errors);
        return valid;
    };

    // ******** Submit ********
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const descriptionHTML = wrapImagesWithFigure(
                    rawToHtmlConverter(formData.description.getCurrentContent())
                );

                const payload = {
                    id: data.id,
                    cityid: cityId,
                    section: formData.section,
                    description: descriptionHTML,
                    ish1tag: formData.ish1tag ? 1 : 0,   // ✅ backend always gets 1 or 0
                };


                const res = await cityWiseSectionUpdate(payload);
                if (res.code === 200) {
                    toast.success(res.message || "Section updated successfully");
                    citywisecenterListing();
                    modalOnClose();
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            } finally {
                setSubmitLoading(false);
            }
        }
    };

    const modalOnClose = () => {
        setErrorField({});
        onClose();
    };

    return (
        <ModalBox
            status={open}
            onClose={modalOnClose}
            size="md"
            title="Update Section"
            customizedFooter={
                <Button onClick={handleSubmit} {...submitButtonElement}>
                    Update Section
                </Button>
            }
        >
            <div className="form-group row mt-1">


                <div className="col-sm-12 col-form-label">
                    <Input
                        type="text"
                        name="section"
                        value={formData.section}
                        onChange={(e) =>
                            setFormData({ ...formData, section: e.target.value })
                        }
                        placeholder="Enter Section Heading"
                        className="form-control"
                        label={"Heading"}
                        error={errorField.section}
                        required
                    />
                </div>

                <div className="col-sm-12 mt-2">
                    <label>Description</label>
                    <TextEditor
                        value={formData.description}
                        onChange={(val) =>
                            setFormData({ ...formData, description: val })
                        }
                    />
                    {errorField.description && (
                        <span className="text-danger small">{errorField.description}</span>
                    )}
                </div>

                <div className="col-sm-12 mt-3 d-flex align-items-center">
                    <Switch
                        checked={formData.ish1tag === 1}   // ✅ ON if 1
                        onChange={() =>
                            setFormData({
                                ...formData,
                                ish1tag: formData.ish1tag === 1 ? 0 : 1,  // ✅ toggle 1 ↔ 0
                            })
                        }
                    />
                    <span className="ms-2">H1 Tag</span>
                </div>
            </div>
        </ModalBox>
    );
};

export default UpdateCityWiseSection;
